
// Main Body SECTION
const mainBody = {
  gradientColors: "#434343, #000000",
  firstName: "Ricardo",
  middleName: "",
  lastName: "Cardoso Pereira",
  icons: [
    {
      image: "fas fa-graduation-cap",
      url: "https://scholar.google.com/citations?user=mHupdO8AAAAJ",
    },
    {
      image: "fas fa-building-columns",
      url: "https://www.cisuc.uc.pt/en/people/ricardo-pereira",
    },
    {
      image: "fab fa-github",
      url: "https://github.com/ricardodcpereira",
    },
    {
      image: "fas fa-envelope",
      url: "mailto:rdpereira@dei.uc.pt",
    },
  ],
};

export { mainBody };
